exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subtitle {\n  font-weight: bold; }\n\np {\n  font-size: 14px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-worksheet/import-data/import-data.component.scss
// module id = ../../../../../src/app/order-worksheet/import-data/import-data.component.scss
// module chunks = main